import { render, staticRenderFns } from "./widget-discover-people.vue?vue&type=template&id=e1033850&"
import script from "./widget-discover-people.vue?vue&type=script&lang=js&"
export * from "./widget-discover-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports